/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Vekn_Id_Required_To_RegisterInputs */



/**
* | output |
* | --- |
* | "You need a VEKN ID to register." |
*
* @param {Tournament_Vekn_Id_Required_To_RegisterInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_vekn_id_required_to_register = /** @type {((inputs?: Tournament_Vekn_Id_Required_To_RegisterInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Vekn_Id_Required_To_RegisterInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez besoin d'un identifiant VEKN pour vous inscrire.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Necesitas un ID de VEKN para inscribirte.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você precisa de um ID VEKN para se inscrever.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Hai bisogno di un ID VEKN per iscriverti.")
	return /** @type {LocalizedString} */ ("You need a VEKN ID to register.")
});